import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/screenshare.tsx
var Screenshare = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("rect", {
		x: "2",
		y: "4",
		width: "20",
		height: "16",
		rx: "3",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ jsx("path", {
		d: "M12 15V9M12 9L14.5 11.5M12 9L9.5 11.5",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})] }) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 4C3.34315 4 2 5.34315 2 7V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V7C22 5.34315 20.6569 4 19 4H5ZM12.5303 8.46967C12.2374 8.17678 11.7626 8.17678 11.4697 8.46967L8.96967 10.9697C8.67678 11.2626 8.67678 11.7374 8.96967 12.0303C9.26256 12.3232 9.73744 12.3232 10.0303 12.0303L11.25 10.8107V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V10.8107L13.9697 12.0303C14.2626 12.3232 14.7374 12.3232 15.0303 12.0303C15.3232 11.7374 15.3232 11.2626 15.0303 10.9697L12.5303 8.46967Z",
		fill: "currentColor"
	})
});
//#endregion
export { Screenshare };
